import React from 'react'
import BigTagOptions from './big_tag_options'
import TeamSigil from './team_sigil'

class BigTag extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            menuOpen: false,
            bigTagHours: true,
        }
    }

    showModal = () => {
        this.props.editTag(this.props.bigTag)
    }

    hideDropdown = () => {
        this.setState({
            menuOpen: false,
            bigTagHours: true,
        })
    }
    showDropdown = () => this.setState({menuOpen: true})

    hideInfo = () => {
        this.setState({
            bigTagHours: false,
        })
    }

    toggleTagReport = () => {
        if (this.props.noMenu) return
        this.props.toggleTagReport()
        this.props.onSelect(this.props.bigTag)
    }

    renderInfo = () => {
        const { bigTag } = this.props
        return (
            <div className="big-tag-info">
                <div className="big-tag-status">
                    <span className="big-tag-counts">{bigTag.hours}</span>
                </div>
            </div>
        )
    }

    render() {
        const {
            bigTag, editTag, newTimeEntry, newTimer,
            showMenu, showClose, showInfo,
        } = this.props
        const { bigTagHours } = this.state
        const showOptions = bigTag.canEdit || bigTag.canAddTime
        const teamSigil = TeamSigil(undefined, bigTag.teamSigil)
        const { name } = bigTag

        return (
            <div
                className={ showMenu ? "big-tag show-cursor" : "big-tag"}
                key={bigTag.key}
                style={{backgroundColor: bigTag.color}}
                onMouseLeave={this.hideDropdown}
                onClick={this.toggleTagReport}
                onMouseEnter={this.hideInfo}
            >
                <div className="big-tag-caption">
                    {teamSigil}
                    {name}
                </div>

                {showOptions && <BigTagOptions
                    options={{ showClose }}
                    menuOpen={this.state.menuOpen}
                    showDropdown={this.showDropdown}
                    editTag={editTag}
                    newTimeEntry={newTimeEntry}
                    newTimer={newTimer}
                    bigTag={bigTag}
                    showModal={this.showModal}
                />}
                {bigTagHours && showInfo && this.renderInfo(bigTag)}
            </div>
        )
    }
}

export default BigTag


// WEBPACK FOOTER //
// ./src/components/big_tag.jsx